<template>
<div>

    <div class="row" v-if="roomName && sala_grupo">

        <div class="col col-12 col-md-8" v-if="false">

            <div class="mb-3 d-flex" v-if="master">

                <button class="btn btn-primary btn-sm mr-2" @click="createChat(sala)" v-if="1 == 0"> 
                    <i class="fas fa-video mr-2"></i>
                    Iniciar
                </button>

                <button type="button" class="btn btn-outline-primary btn-sm mr-2" @click="listar ()">
                    Listar
                </button>

                <button type="button" class="btn btn-outline-primary btn-sm mr-2" @click="sair ()" v-if="1 == 0">
                    Sair
                </button>

                <button type="button" class="btn btn-outline-primary btn-sm mr-2" @click="share ()" v-if="1 == 0">
                    Share
                </button>

            </div>

        </div>

        <div class="col col-12">
            <div v-if="!sala && participants.length > 0">
                <small class="list-group-item mr-2" v-for="(part, ipx) in participants" :key="ipx">
                    <span v-if="ipx">/</span>
                    {{ part }}
                </small>
            </div>
            <template v-if="false">
                <div v-for="(log, idx) in topLog" :key="idx" class="small text-right">
                    {{ log }} <a href="#" @click.prevent="showlogs()">(console)</a>
                </div>
            </template>
        </div>

    </div>

    <p class="alert alert-danger" v-if="error_msg">{{ error_msg }}</p>

    <div v-if="1 == 0">{{ activeRoom ? 'active Room' : 'Not active Room' }} / {{ participants.length }} / {{ participants }}</div>

    <div class="row">
        
        <div class="col-md-12">

            <!-- Video -->
            <div>
                <div class="row" id="video-container" :class="videoState == 'max' ? 'video-max' : ''">
                    <div class="col">
                        <div class="bg-light text-muted text-truncate small" v-if="roomName">
                            {{ roomName }}
                            <template v-if="gravando">
                                <i class="fas fa-circle text-danger mx-2" aria-hidden="true"></i>
                                Gravando...
                            </template>
                            <span v-if="participants && participants.length" class="mr-3">
                                {{ participants.join(', ') }}
                            </span>
                        </div>
                        <div class="text-center bg-white d-flex flex-column justify-content-center" style="min-height: 400px;" v-if="!participants.length">
                            <span class="display-4">
                                {{ loading ? 'Iniciando...' : ( activeRoom ? 'Aguardando Participante' : 'Chamada não iniciada' ) }}
                            </span>
                        </div>
                        <div class="border bg-white" ref="remoteTrack" id="remoteTrack" 
                            @mousedown="mousedown" @mousemove="mousemove" @mouseup="mouseup" @mouseleave="mouseleave"
                            :class="videoState == 'max' ? 'video-max-track' : ''" v-show="participants.length"></div>
                        <div id="localTrack"></div>
                        <div class="text-center" :id="( roomName && participants.length <= 1 ) ? 'botoes-video' : 'botoes-video-top'">
                            <span v-if="loading">
                                <az-loading :nomsg="true" />

                                <div class="spinner-border mx-3" role="status" v-if="1 == 0">
                                    <span class="sr-only">Loading...</span>
                                </div>      
                            </span>
                            <span v-else-if="!loading && roomName" class="base-comando p-3">
                                <button type="button" class="btn btn-outline-danger btn-sm mr-2" @click="sair ()"
                                    data-toggle="tooltip" data-placement="top" title="Encerrar Video Chamada">
                                    <i class="fas fa-stop fa-fw" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-outline-danger btn-sm mr-2" @click="gravar ()" v-if="1 == 1 && master && !block_gravar">
                                    <i class="fas fa-circle fa-fw" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-outline-secondary btn-sm mr-2">
                                    <i class="fas fa-fw" :class="state.audio ? 'fa-microphone' : 'fa-microphone-slash'" @click="toggleAudio()"></i>
                                </button>
                                <button type="button" class="btn btn-outline-secondary btn-sm mr-2" @click="toggleVideo()">
                                    <i class="fas fa-fw" :class="state.video ? 'fa-video' : 'fa-video-slash'"></i>
                                </button>
                                <button type="button" class="btn btn-outline-success btn-sm mr-2" 
                                    v-if="master" :disabled="loadingShare" @click="share()"
                                    data-toggle="tooltip" data-placement="top" title="Compartilhar link da chamada com o paciente.">
                                    <i class="fas fa-link fa-fw" v-if="!loadingShare"></i>
                                    <div class="spinner-border spinner-border-sm" role="status" v-else>
                                        <span class="sr-only">Loading...</span>
                                    </div>      
                                </button>
                                <template v-if="!tela_pequena">
                                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" v-if="videoState == 'restore'" @click="toggleVideoSize()"
                                        data-toggle="tooltip" data-placement="top" title="Ampliar visualização da vídeo chamada.">
                                        <i class="far fa-window-maximize fa-fw"></i>
                                    </button>
                                    <button type="button" class="btn btn-outline-primary btn-sm mr-2" v-if="videoState == 'max'" @click="toggleVideoSize()"
                                        data-toggle="tooltip" data-placement="top" title="Restaurar visualização da vídeo chamada.">
                                        <i class="far fa-window-restore fa-fw"></i>
                                    </button>
                                </template>
                            </span>
                            <span v-else>
                                <button type="button" class="btn btn-success mx-3" @click="createChat(sala)">
                                    <i class="fas fa-play mr-2" aria-hidden="true"></i>
                                    Iniciar Vídeo Chamada
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

    </div>

   <!-- Modal -->
    <div class="modal fade" id="shareVideoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Convidar para Video Chamada</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body" v-if="shareData">
                <div class="list-group">
                    <a href="#" class="list-group-item list-group-item-action d-flex"
                        @click.prevent="copiar_clipboard('Link de acesso', shareData.link)">
                        <i class="fas fa-copy text-primary fa-2x mr-3"></i>
                        <span class="lead">Copiar Link de Acesso</span>
                    </a>
                    <a :href="whatsapp_link ()" v-if="telefone" :target="whatsapp_link () ? '_blank' : ''"  class="list-group-item list-group-item-action">
                        <i class="fa fa-whatsapp text-success fa-2x mr-3" aria-hidden="true"></i>
                        <span class="lead">Enviar Link pelo Whatsapp</span>
                        <div class="small text-muted">{{ $util.formatMask(telefone, telefone.length == 10 ? 'tel' : 'cel') }}</div>
                    </a>
                    <a href="#" class="list-group-item list-group-item-action d-flex" @click.prevent="enviar_link_telegram()" v-if="atendimento && atendimento.paciente.cadastro.st_telegram_chat_id" :disabled="$store.state.loading">
                        <i class="fab fa-telegram-plane text-info fa-2x mr-3"></i>
                        <span class="lead">Enviar Link pelo Telegram</span>
                        <div class="small text-muted">{{ $util.formatMask(telefone, telefone.length == 10 ? 'tel' : 'cel') }}</div>
                    </a>
                    <a href="#" @click.prevent="enviar_link_email ()" v-if="atendimento && atendimento.paciente.cadastro.st_email" class="list-group-item list-group-item-action">
                        <i class="fa-regular fa-envelope-open fa-2x mr-3"></i>
                        <span class="lead">Enviar Link por e-mail</span>
                        <div class="small text-muted">{{ atendimento.paciente.cadastro.st_email }}</div>
                    </a>

                    <div class="spinner-border mt-3" role="status" v-if="$store.state.loading">
                        <span class="sr-only">Loading...</span>
                    </div>      
                </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
          </div>
        </div>
      </div>
    </div>


</div>
</template>

<script>
import $ from 'jquery';
import Twilio from 'twilio-video'
import AzLoading from '../../util/AzLoading.vue';
//, { createLocalVideoTrack, createLocalTracks } 

export default {
    name: "Video",

    components: {
        AzLoading,
    },

    data() {
        return {
            loading: false,
            loadingMsg: "",
            data: {},
            localTrack: false,
            videoLocalTrack: '', 
            audioLocalTrack: null, 
            remoteTrack: '',
            remoteTracks: [],
            activeRoom: '',
            previewTracks: null,
            identity: '',
            roomName: null,
            startBus: false,
            logs: [], 
            participants: [], 
            shareData: null,
            loadingShare: false, 
            videoState: 'restore',
            error_msg: "",
            state: { 
                video: true,
                audio: true, 
            },
            gravando: false, 
            recordedChunks: [], 
            mediaRecorder: null, 
            offsetX: 0, 
            offsetY: 0, 
            isDragging: false,
        }
    },

    props: ['username', 'sala', 'direto', 'token', 'master', 'telefone', 'email', 'atendimento', 'block_gravar'], // props that will be passed to this component

    computed: { 
        sala_grupo: function () { 
            return this.roomName && this.roomName.indexOf('grupo-') >= 0;
        },
        
        topLog: function () { 
            if ( !this.logs.length )
                return this.logs;

            return [
                this.logs[this.logs.length - 1]
            ];
        },

        tela_pequena: function () { 
            return !this.master && document.documentElement.clientWidth < 800;
        }

    },

    created() {
        // When a user is about to transition away from this page, 
        // disconnect from the room, if joined.
        window.addEventListener('beforeunload', this.leaveRoomIfJoined);
    },  

    methods: {
        // mouse methods...
        mouseleave() { 
            this.isDragging = false;

            const video = document.getElementById("remoteTrack");

            if ( video )
                video.style.cursor = 'grab';
        }, 

        mousedown(e) {
            if (window.pageYOffset <= 400) {
                return;
            }

            const video = document.getElementById("remoteTrack");

            this.offsetX = e.clientX - video.offsetLeft;
            this.offsetY = e.clientY - video.offsetTop;
            this.isDragging = true;
            video.style.cursor = 'grabbing';
        }, 

        mousemove(e) {
            if (this.isDragging) {

                const video = document.getElementById("remoteTrack");

                video.style.left = `${e.clientX - this.offsetX}px`;
                video.style.top = `${e.clientY - this.offsetY - 90}px`;

            }
        }, 

        mouseup () {

            const video = document.getElementById("remoteTrack");

            this.isDragging = false;
            video.style.cursor = 'grab';

        }, 

        // Outros Métodos...

        enviar_link_telegram() { 
            this.$util.atualizar(this, { 
                service: 'telegram', 
                func: 'link_teleatendimento',
                dados: { 
                    id_marcacao: this.atendimento.marcacao.id_marcacao,
                },
                callback: () => { 
                    $('#shareVideoModal').modal('hide');
                }
            });
        },

        enviar_link_email () { 

            if ( !confirm('Confirma enviar o link de acesso por e-mail?') ) { 
                return;
            }

            this.email_enviado = true; 

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'enviar_link_email', 
                dados: { 
                    link: this.shareData.link, 
                    nome: this.atendimento.paciente.st_nome, 
                    email: this.atendimento.paciente.cadastro.st_email, 
                    id_atendimento: this.atendimento.id_atendimento, 
                }, 
                toast: true, 
                msg: 'e-mail enviado.', 
                modal: 'shareVideoModal', 
            });
            
        },

        handleDataAvailable(event) {
            if ( !this.recordedChunks.length )
                console.log("Gravando", event);

            if (typeof event.data === 'undefined') return;
            if (event.data.size > 0) {
                this.recordedChunks.push(event.data);
            }
        },

        async gravar () { 
            if ( !this.gravando ) { 

                if ('MediaRecorder' in window) {
                   // everything is good, let's go ahead
                } else {
                    alert("Esse browser não suporta gravação de vídeo local.");
                }

                let options;

                if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
                    options = {mimeType: 'video/webm; codecs=vp9'};
                } else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) {
                    options = {mimeType: 'video/webm; codecs=vp8'};
                } else {
                    alert('Gravação não disponível.');
                    return;
                }

                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: true
                });

                /*
                const mediaStream = new MediaStream();
                mediaStream.addTrack(this.videoLocalTrack.mediaStreamTrack);
                mediaStream.addTrack(this.audioLocalTrack.mediaStreamTrack);

                console.log(this.remoteTracks);
                
                this.remoteTracks.forEach(track => { 
                    console.log('Incluindo Track: ', track);
                    console.log('mediaStreamtrack: ', track.mediaStreamTrack);
                    mediaStream.addTrack(track.mediaStreamTrack);
                });
                */
                 
                this.gravando = true;

                this.recordedChunks = [];
                this.mediaRecorder = new MediaRecorder(mediaStream, options);
                this.mediaRecorder.ondataavailable = this.handleDataAvailable;
                this.mediaRecorder.start(3000);

            } else { 

                this.gravando = false;
                this.mediaRecorder.requestData();
                this.mediaRecorder.stop();

                //console.log('Chunks', this.recordedChunks);

                let blob = new Blob(this.recordedChunks, {
                    type: 'video/webm'
                });

                //console.log('Blob', blob);

                var url = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = url;
                a.download = 'consulta.webm';
                a.click();
                window.URL.revokeObjectURL(url);

                this.recordedChunks = [];

            }

        },

        toggleAudio () { 
            this.state.audio = !this.state.audio;
            this.state.audio ? this.audioLocalTrack.enable() : this.audioLocalTrack.disable(); 
        },

        toggleVideo () { 
            this.state.video = !this.state.video;
            this.state.video ? this.videoLocalTrack.enable() : this.videoLocalTrack.disable(); 
        },

        showlogs () { 
            console.log(this.logs);
        },

        toggleVideoSize () { 
            $('[data-toggle="tooltip"]').tooltip('hide');
            this.videoState = ( this.videoState == 'max' ? 'restore' : 'max' );
        },
        
        whatsapp_link () { 
            if ( this.shareData ) { 

                let nl = "%0D%0A";
                let msg = "Prezado(a) ";
                let celular = this.telefone;

                celular = "55" + celular;

                msg = msg + nl;
                msg = msg + "Link para acesso a consulta via vídeo chamada com Dr(a) " + this.$store.state.user.search + ":" + nl;
                msg = msg + "> " + encodeURIComponent(this.shareData.link);

                return "https://wa.me/" + celular + "?text=" + msg;
                
            }
                
        },

        copiar_clipboard (titulo, text) { 
            if (!navigator.clipboard) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position="fixed";  //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }

                document.body.removeChild(textArea);
            } else { 
                navigator.clipboard.writeText(text).then(function() {
                    console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            this.$toast.add({
                    severity: "success",
                    summary: "Atenção",
                    detail: titulo + " copiado para a área de transferência.",
                    life: 3000
                });
        },

        share() { 
            this.loadingShare = true;

            $('[data-toggle="tooltip"]').tooltip('hide');

            this.axios.get('/video/share?room=' + this.sala
                    + ( this.atendimento ? '&mrc=' + this.atendimento.marcacao.id_marcacao : '' )
                )
                .then(res => { 
                    console.log(res.data);
                    this.shareData = res.data;
                    $('#shareVideoModal').modal('show');
                })
                .finally(() => {
                    this.loadingShare = false;
                });
        },

        sair () { 
            if ( this.gravando )
                this.gravar ();

            $('[data-toggle="tooltip"]').tooltip('hide');    

            this.videoState = 'restore';

            if ( this.activeRoom ) { 
                this.leaveRoom ();
            } else { 
                this.complete ();
            }
        },

        complete () { 

            if ( this.master ) { 

                this.axios.get('/video/complete?room=' + this.sala
                        + ( this.atendimento ? '&mrc=' + this.atendimento.marcacao.id_marcacao : '' )
                    )
                    .then(res => { 
                        console.log('completed', res);
                    });

            }

        },

        listar () { 
            return this.axios.get('/video/list?room=' + this.sala )
                .then(res => { 
                    console.log('Rooms:', res.data);
                });
        },

        leaveRoom () { 
            if ( this.activeRoom ) { 

                console.log(this.activeRoom);

                // this.detachParticipantTracks(this.activeRoom.localParticipant);
                if ( this.videoLocalTrack ) { 
                    this.videoLocalTrack.stop ();
                    this.detachTracks([this.videoLocalTrack]);
                    this.localTrack = false;
                }

                this.leaveRoomIfJoined ();

                this.dispatchLog("Chamada encerrada.");
                
                this.roomName = "";
                this.activeRoom = "";
                this.participants = [];

                /*
                if ( this.videoLocalTrack ) { 
                    this.detachTracks([this.videoLocalTrack]);
                    this.localTrack = false;
                }
                */

            }
        },

        // Incluir e Remover Participante
        appendName(identity) {
            if ( !this.participants.find(item => item == identity) ) { 
                this.participants.push(identity);
            }
        },

        removeName(identity) {
            if (identity) {
                let index = this.participants.findIndex(item => item == identity);

                if ( index >= 0 ) {
                    this.participants.splice(index, 1);
                }
            }
        },

        // track publication
        trackPublished(publication, container) {
            console.log('publication', publication);

            if (publication.isSubscribed) {
                this.attachTrack(publication.track, container);
                this.remoteTracks.push(publication.track);
            }

            publication.on('subscribed', (track) => {
                this.dispatchLog('Subscribed to ' + publication.kind + ' track');
                this.attachTrack(track, container);
                this.remoteTracks.push(track);
            });

            publication.on('unsubscribed', this.detachTrack);
        },

        trackUnpublished(publication) {
            this.dispatchLog(publication.kind + ' track was unpublished.');
        },

        // Conexão de Participante
        participantConnected(participant, container) {
            console.log('participantConnected', participant);

            let selfContainer = document.createElement('span');
            selfContainer.id = `participantContainer-${participant.identity}`;

            container.appendChild(selfContainer);
            this.appendName(participant.identity, selfContainer);

            participant.tracks.forEach((publication) => {
                this.trackPublished(publication, selfContainer);
            });

            participant.on('trackPublished', (publication) => {
                this.trackPublished(publication, selfContainer);
            });

            participant.on('trackUnpublished', this.trackUnpublished);
        },

        // Generate access token
        getAccessToken() {
            if ( this.direto ) { 
                return this.axios.get('/video/direct/token?room=' + this.sala + 
                    '&identity=' + ( this.username ? this.username : this.identity ) + 
                    '&key=' + this.token + 
                    ( this.atendimento ? '&mrc=' + this.atendimento.marcacao.id_marcacao : '' )
                );    
            } else { 
                return this.axios.get('/video/token?room=' + this.sala + '&identity=' + this.identity
                    + ( this.atendimento ? '&mrc=' + this.atendimento.marcacao.id_marcacao : '' )
                );
            }
        },

        // Trigger log events 
        dispatchLog(message) {
            this.logs.push(message);
        },

        container_video_add(container, track) { 
            let element = track.attach();

            if ( this.sala_grupo ) { 
                element.className = "col-md-2";

                element.addEventListener('click', el => {
                    console.log('elc', el);
                    console.log('elc source', el.srcElement);

                    if ( el && el.srcElement ) { 
                        el.srcElement.classList.toggle('maximizado');
                        el.srcElement.classList.toggle('col-md-2');
                    }
                });
            }

            console.log('track', track);
            console.log('el', element);

            container.appendChild(element);
        },

        // Attach the Tracks to the DOM.
        attachTrack(track, container) {
            this.container_video_add(container, track);
            //container.appendChild(track.attach());
        },

        attachTracks(tracks, container) {
            console.log('attachTracks', tracks);
            tracks.forEach(function(track) {
                this.container_video_add(container, track);
                //container.appendChild(track.attach());
            });
        },

            // Attach the Participant's Tracks to the DOM.
        attachParticipantTracks(participant, container) {
            console.log('attachParticipantTracks', participant);

            this.appendName(participant.identity, container);

            participant.tracks.forEach((publication) => {
                console.log('publish track', publication);
                this.trackPublished(publication, container);
            });
            participant.on('trackPublished', (publication) => {
                console.log('on publish track', publication);
                this.trackPublished(publication, container);
            });
            participant.on('trackUnpublished', (publication) => { 
                console.log('on unpublish track');
                this.trackUnpublished(publication);
            });

            //let tracks = Array.from(participant.tracks.values());
            //this.attachTracks(tracks, container);
        },

        // Detach the Tracks from the DOM.
        // Detach given track from the DOM.
        detachTrack(track) {
            if ( track ) { 
                console.log('detachTrack', track);
                track.detach().forEach(function(element) {
                    element.remove();
                });
            }
        },

        detachTracks(tracks) {
            console.log('detachTracks', tracks);
            tracks.forEach( (track) => {
                console.log('s:detachTrack', track);
                if ( track ) { 
                    track.detach().forEach((detachedElement) => {
                        detachedElement.remove();
                    });
                }
            });
        },

        // Detach the Participant's Tracks from the DOM.
        detachParticipantTracks(participant) {
            console.log('detachParticipantTracks', participant);
            let tracks = Array.from(participant.tracks.values());
            this.detachTracks(tracks);
        },

        // Leave Room.
        leaveRoomIfJoined() {
            console.log( 'leaveRoomIfJoined', this.activeRoom);
            if (this.activeRoom) {
                this.activeRoom.disconnect();
                this.complete ();
            }
        },

        // Create a new chat
        createChat(room_name) {
            if ( this.loading )
                return;

            let elem = document.getElementById('basevideo');

            if (elem)
                elem.scrollIntoView({behavior: "smooth"});

            this.state = { 
                video: true,
                audio: true, 
            };

            this.remoteTracks = [];
            this.loadingMsg = "Iniciando...";
            this.loading = true;

            console.log('create chat', this.sala);

            this.getAccessToken()
                .then((data) => {
                    console.log('token', data);

                    this.roomName = null;

                    const token = data.data.token;
                    
                    let connectOptions = {
                        name: room_name,
                        type: data.data.room.type,
                        audio: true,
                        video: { width: 640 }
                    };

                    console.log('connectOptions', connectOptions);
                    
                    // before a user enters a new room,
                    // disconnect the user from they joined already
                    this.leaveRoomIfJoined();
                    
                    // remove any remote track when joining a new room
                    document.getElementById('remoteTrack').innerHTML = "";

                    this.loadingMsg = "Carregando Vídeo...";

                    Twilio.connect(token, connectOptions)
                        .then((room) => {
                            this.error_msg = "";

                            console.log('Started Room: ', room);
                            this.dispatchLog('Chamada iniciada: '+ room_name);

                            if ( process.env.VUE_APP_GTAG ) { 

                                let action = 'video-chamada';
                                let label = ( this.direto ? 'Paciente' : this.$store.state.user.st_login ) + ' / ' + room_name;

                                this.$gtag.event(action, {
                                    'event_category': window.redir,
                                    'event_label': label,
                                    'value': 1
                                });

                            }

                            // set active toom
                            this.activeRoom = room;
                            this.roomName = room_name;
                            this.loading = false;

                            // Attach the Tracks of all the remote Participants.
                            room.participants.forEach((participant) => {
                                console.log('iniciando participantes', participant);

                                let previewContainer = document.getElementById('remoteTrack');
                                this.attachParticipantTracks(participant, previewContainer);
                            });

                            // When a Participant joins the Room, log the event.
                            room.on('participantConnected', (participant) => {
                                console.log('participantConnected', participant);
                                this.dispatchLog("Entrou: '" + participant.identity + "'");

                                let previewContainer = document.getElementById('remoteTrack');
                                this.participantConnected(participant, previewContainer);
                            });

                            // When a Participant adds a Track, attach it to the DOM.
                            room.on('trackAdded', (track, participant) => {
                                console.log('track addded', track);
                                console.log('track participant', participant);
                                
                                this.dispatchLog(participant.identity + " added track: " + track.kind);
                                let previewContainer = document.getElementById('remoteTrack');
                                this.attachTracks([track], previewContainer);
                            });

                            // When a Participant removes a Track, detach it from the DOM.
                            room.on('trackRemoved', (track, participant) => {
                                console.log('trackRemoved', track);
                                console.log('trackRemoved', participant);

                                this.dispatchLog(participant.identity + " canal removido: " + track.kind);
                                this.detachTracks([track]);
                            });

                            // When a Participant leaves the Room, detach its Tracks.
                            room.on('participantDisconnected', (participant) => {
                                console.log('participant disconnect', participant);

                                let idx = this.participants.findIndex(item => item == participant.identity);

                                if ( idx >= 0 )
                                    this.participants.splice(idx, 1);

                                this.dispatchLog("'" + participant.identity + "' deixou a chamada.");
                                //this.detachParticipantTracks(participant);
                            });

                            room.on('disconnected', () => { 
                                console.log('sala encerrada', room);

                                if (this.previewTracks) {
                                    this.previewTracks.forEach(function(track) {
                                        track.stop();
                                    });
                                    this.previewTracks = null;
                                }

                                //this.detachParticipantTracks(room.localParticipant);
                                //room.participants.forEach(this.detachParticipantTracks);

                                room.participants.forEach(this.removeName);

                                this.activeRoom = null;
                            });

                            // if local preview is not active, create it
                            if(!this.localTrack) {

                                /*
                                createLocalVideoTrack()
                                    .then(track => {
                                        if ( !track ) { 
                                            this.dispatchLog("Falha em iniciar o vídeo.");
                                        } else { 
                                            console.log('track local', track);
                                            let localMediaContainer = document.getElementById('localTrack');
                                            localMediaContainer.appendChild(track.attach());
                                            this.videoLocalTrack = track;
                                            this.localTrack = true;
                                            console.log('track local criada');
                                        }
                                    });
                                */

                                room.localParticipant.audioTracks.forEach(publication => {
                                    this.audioLocalTrack = publication.track;
                                });

                                room.localParticipant.videoTracks.forEach(publication => {
                                    const element = publication.track.attach();

                                    this.videoLocalTrack = publication.track;
                                    this.localTrack = true;
                                    
                                    let localMediaContainer = document.getElementById('localTrack');
                                    localMediaContainer.appendChild(element);
                                })

                            }

                            if ( !this.master && document.documentElement.clientWidth < 800 ) {
                                // this.videoState = 'max';
                            }


                        })
                        .catch(error => { 
                            console.log('Falha na conexão', error);
                            this.error_msg = 'Falha na conexão: ' + error.message;
                            this.loading = false; 
                        });

                })
                .catch(error => { 
                    console.log('Falha na conexão', error);
                    this.loading = false; 
                });
        },

        posicao_video() {

            if ( this.loading || this.videoState != 'restore' || !this.roomName )  
                return;

            // Get the header
            let video = document.getElementById("remoteTrack");

            if ( video ) { 

                if (window.pageYOffset > 400) {
                    video.classList.add("sticky");
                } else {
                    video.classList.remove("sticky");
                }

            }
        }

    },

    beforeDestroy () { 
        if ( this.roomName ) { 
            this.sair();
        }
    },

    mounted () { 

        // When the user scrolls the page, execute myFunction

        if ( this.direto ) { 

            this.createChat(this.sala);

        } else { 

            window.onscroll = () => { 
                this.posicao_video(); 
            }

        }

    }
}
</script>

<!-- 
// border: 1px solid rgb(124, 129, 124); 
// object-fit: fill;-->

<style>
.base-comando:hover { 
    background-color: white;
}

#video-container { 
    min-height: 400px;
}

#remoteTrack { 
    min-height: 400px;
}

#remoteTrack video {
    width: 100%;
    object-fit: contain;
    max-height: 400px;
}

.video-max {
 position: fixed; 
 top: 0px;
 left: 0px;
 width: 100%;
 height: 100%;
 margin-right: 0px;
 margin-left: 0px;
 padding: 0px;
 z-index: 1040; 
 animation: az-surgir 0.5s;
}

.video-max #remoteTrack { 
    min-width: 100% !important;
    min-height: 100% !important;
}

.video-max-track video { 
    max-height: 100vh !important;
}

.remote_video_container2 {
    left: 0;
    margin: 0;
}
   
#localTrack2 {
    border: 3px solid rgb(124, 129, 124);
    margin: 0px;
    max-width: 50% !important;
    background-repeat: no-repeat;
}


#botoes-video { 
    position: absolute;
    left: 0;
    bottom: 20px;
    width: 100%;
    text-align: center;
    font-size: 18px;
}

#botoes-video-top { 
    position: absolute;
    left: 0;
    top: 20px;
    width: 100%;
    text-align: center;
    font-size: 18px;
}



@media (max-device-width:768px) {
    #localTrack { 
        position: absolute;
        top: 8px;
        right: 24px;
        max-width: 100px !important;
        background-repeat: no-repeat;
        padding: 0px;
    }

    #localTrack video { 
        max-width: 100px;
        object-fit: fill;  
    }
}

@media (min-device-width:768px) {

    #localTrack { 
        position: absolute;
        top: 8px;
        right: 24px;
        max-width: 200px !important;
        background-repeat: no-repeat;
        min-width: 100px;
        min-height: 50px;
        padding: 0px;
    }

    #localTrack video { 
        max-width: 200px;
        object-fit: fill;  
    }

}

@media (min-device-width:992px) {
 
    .sticky {
        margin-top: 90px;
        position: fixed;
        top: 0;
        right: 30px;
        height: 150px !important;
        min-height: 0px !important;
        width: 20%;
        z-index: 10;
        animation: az-surgir 1s;
        cursor: 'grab';
    }
}


@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

.maximizado { 
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}

</style>